export interface ComparisonData {
  title: string;
  description: string;
  columns: string[];
  specifications: {
    name: string;
    values: (string | string[])[];
  }[];
}

export const guniWheelData: ComparisonData = {
  title: "COMPARE OUR UNIVERSAL WHEEL MODELS",
  description: "Quickly compare all Guniwheel™ models side-by-side and find the universal wheel that best fits your vehicle type, workshop needs, and load requirements. This chart provides a clear overview of specifications, capacities, and compatibility to help you choose confidently.",
  columns: ["GUNI WHEEL 45S", "GUNI WHEEL 56", "GUNI WHEEL 80"],
  specifications: [
    {
      name: "BOLT PATTERN COMPATIBILITY",
      values: ["4-lug / 5-lug", "5-lug / 6-lug", "8-lug"]
    },
    {
      name: "PCD OPTIONS",
      values: [
        ["4×98–130", "5×98–130"],
        ["5×135–150", "6×135–156"],
        ["8×165–210"]
      ]
    },
    {
      name: "SAFE OPERATING SPEED",
      values: ["5 mph / 8 kph", "5 mph / 8 kph", "5 mph / 8 kph"]
    },
    {
      name: "OVERALL DIAMETER",
      values: ["57.15 cm", "57.15 cm", "57.15 cm"]
    },
    {
      name: "HUB CENTER DIAMETER",
      values: ["77 mm", "110 mm", "140 mm"]
    },
    {
      name: "OFFSET (NEGATIVE)",
      values: ["94 mm", "51 mm", "60 mm"]
    },
    {
      name: "RECOMMENDED LOAD CAPACITY",
      values: ["1,587 kg", "1,134 kg", "1,587 kg"]
    },
    {
      name: "WEIGHT",
      values: ["15.42 kg", "14.51 kg", "19.50 kg"]
    },
    {
      name: "OVERSIZED BRAKE CLEARANCE",
      values: ["Yes", "No", "No"]
    },
    {
      name: "WASHER REQUIREMENT",
      values: ["N/A", "Yes", "Yes"]
    },
    {
      name: "FREE-SPIN HUB OPTION",
      values: ["Available*", "No", "No"]
    },
    {
      name: "SUITABLE FOR ROAD USE",
      values: ["No", "No", "No"]
    }
  ]
};

export const guniWheelXData: ComparisonData = {
  title: "COMPARE OUR GUNI WHEEL X-SERIES MODELS",
  description: "Explore the full Guniwheel™ X-Series—designed for vehicles that require wider bolt compatibility, higher weight capacity, and the ability to move cars with locked drivetrains, seized brakes, or dead batteries. This chart helps you quickly identify which X-Series model is the best fit for your workshop needs and vehicle types.",
  columns: ["GUNI WHEEL X56", "GUNI WHEEL X60", "GUNI WHEEL X80"],
  specifications: [
    {
      name: "BOLT PATTERN COMPATIBILITY",
      values: ["4-lug / 5-lug", "5-lug / 6-lug", "8-lug"]
    },
    {
      name: "PCD OPTIONS",
      values: [
        ["4×98–130", "5×98–130"],
        ["5×135–150", "6×135–156"],
        ["8×165–210"]
      ]
    },
    {
      name: "FULL ROTATION (FREE-SPIN)",
      values: ["Yes", "Yes", "Yes"]
    },
    {
      name: "INTENDED USE",
      values: [
        ["Passenger cars", "& light trucks"],
        ["Heavy SUVs &", "mid-size trucks"],
        ["HD/3-ton", "commercial vehicles"]
      ]
    },
    {
      name: "SAFE OPERATING SPEED",
      values: ["5 mph / 8 kph", "5 mph / 8 kph", "5 mph / 8 kph"]
    },
    {
      name: "OVERALL DIAMETER",
      values: ["57.15 cm", "57.15 cm", "60 mm"]
    },
    {
      name: "CENTER HUB BORE",
      values: ["77 mm", "110 mm", "140 mm"]
    },
    {
      name: "NEGATIVE OFFSET",
      values: ["94 mm", "51 mm", "60 mm"]
    },
    {
      name: "RECOMMENDED LOAD CAPACITY",
      values: ["1,100 kg", "1,134 kg", "1,588 kg"]
    },
    {
      name: "WHEEL WEIGHT",
      values: ["15.4 kg", "14.5 kg", "19.5 kg"]
    },
    {
      name: "BEST FOR",
      values: [
        ["Collision", "shops"],
        ["EVs &", "seized brakes"],
        ["Heavy-duty", "shops"]
      ]
    },
    {
      name: "SUITABLE FOR ROAD USE",
      values: ["No", "No", "No"]
    }
  ]
};